import { render, staticRenderFns } from "./wrapper-pagination-date.vue?vue&type=template&id=8fdd7f2e&"
import script from "./wrapper-pagination-date.vue?vue&type=script&lang=js&"
export * from "./wrapper-pagination-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports